import { LocationContacts } from '@hakimo-ui/hakimo/feature-shared';
import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import { Page } from '@hakimo-ui/hakimo/ui-layout';
import { useCanVoiceCall } from '@hakimo-ui/hakimo/util';
import { useNavigate } from 'react-router-dom';
import AlarmSummary from '../alarm-details/alarm-summary/AlarmSummary';
import Floorplan from '../alarm-details/floorplan/Floorplan';
import PageActions from '../alarm-details/page-actions/PageActions';
import AlarmDetailsSOP from '../alarm-details/sop/AlarmDetailsSOP';
import { useTrackAlarmEvents } from '../alarm-details/useTrackAlarmEvents';
import NeighboringEvent from './NeighbouringEvent';
import AlarmMediaEvent from './ScanRawAlarmMedia';
import ScanRawAlarmStatus from './ScanRawAlarmStatus';
import ScanRawAlarmUpdates from './ScanRawAlarmUpdates';

interface Props {
  event: UnifiedAlarm;
  onRefresh: () => void;
  sharedToken?: string;
}

function ScanRawAlarmDetails({ event, sharedToken, onRefresh }: Props) {
  const { onTrackTalkdown } = useTrackAlarmEvents(event.id);
  const navigate = useNavigate();
  const canVoiceCall = useCanVoiceCall();
  const onClickBack = () => navigate('/alarms');

  return (
    <Page
      title={event.id}
      subtitle="Alarm Details"
      pageActions={[
        <PageActions
          key="page-actions"
          alarmId={event.id}
          product="scan"
          sharedToken={sharedToken}
          onRefresh={onRefresh}
          timestamp={String(event.alarmStartTime)}
        />,
      ]}
      onClickBack={!sharedToken ? onClickBack : undefined}
    >
      <div className="lg:grid-cols-3/4-1/4 bg-hakimo-light-bg dark:bg-hakimo-dark-bg grid grid-cols-1 items-start gap-2 pb-2">
        <div className="grid gap-2">
          <AlarmMediaEvent
            event={event}
            onTalkdown={onTrackTalkdown}
            sharedToken={sharedToken}
          />
          <div className="grid grid-cols-2 gap-2">
            <ScanRawAlarmStatus event={event} sharedToken={sharedToken} />
            <ScanRawAlarmUpdates
              eventId={event.id}
              timestamp={String(event.alarmStartTime)}
              sharedToken={sharedToken}
              alarmGroupId={event.alarmGroupId}
            />
            <NeighboringEvent event={event} sharedToken={sharedToken} />
            <Floorplan locationId={String(event.location?.id ?? '')} />
            <AlarmDetailsSOP
              locationId={String(event.location?.id ?? '')}
              tenantId={event.location?.tenant_id ?? ''}
            />
          </div>
        </div>

        <div className="sticky z-0">
          <AlarmSummary event={event} />
          <div className="mt-2" />
          {canVoiceCall && event.location && (
            <div className="dark:bg-ondark-bg-1 bg-onlight-bg-1 min-h-[4rem] flex-1 overflow-auto rounded-lg px-6 pt-4">
              <LocationContacts locationId={event.location.id} />
            </div>
          )}
        </div>
      </div>
    </Page>
  );
}

export default ScanRawAlarmDetails;
